const enum Routes {
  QR_CODE = 'qrCode',
  OTP = 'otp',
  LOBBY = 'lobby'
}

const enum Headers {
  CompanyUUID = 'Http-X-Seven-Club-Uuid',
  TenantUUID = 'X-Nsft-Seven-Tenant-Uuid',
  Authorization = 'Authorization',
  RequestID = 'X-Request-Id',
  VaixClientID = 'x-vaix-client-id'
}

const enum ErrorCodes {
  OTP_INCORRECT = 40013,
  OTP_EXPIRED = 40016,
  TERMINAL_DISABLED = 40018,
  DUPLICATE_DONGLE_ID = 40021,
  SESSION_ALREADY_ACTIVE = 40022
}

const INACTIVITY_TIMEOUT = 3 * 60 * 1000
const INACTIVITY_NOTIFICATION_DURATION = 3000

export { Routes, Headers, ErrorCodes, INACTIVITY_TIMEOUT, INACTIVITY_NOTIFICATION_DURATION }
